import React from 'react';

const Resume = ({ data: { title, experience, education, skills, testimonials } }) => (
  <div className="card-inner active">
    <div className="card-wrap">
      <div className="content resume">
        <div className="title">{title}</div>
        <div className="content-space noSpace resumeSection">
          <div className="row row-margin border-line-v">
            {[experience, education].map((section, index) => (
              <div key={index} className="col-md-6 colSpace">
                <div className="resume-title border-line-h">
                  <div className="icon">
                    <i className={`fa ${section.icon}`}></i>
                  </div>
                  <div className="name">{section.title}</div>
                </div>
                <div className="resume-items">
                  {section.items.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className={`resume-item border-line-h ${item.active ? 'active' : ''}`}
                    >
                      <div className="date">{item.date}</div>
                      <div className="name">{item.name}</div>
                      <div className="company">{item.company}</div>
                      <p>{item.description}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="content skills">
        <div className="title">{skills.title}</div>
        <div className="content-space noSpace mySkills">
          <div className="row row-margin border-line-v">
            {[skills.backend, skills.databases].map((skillSet, index) => (
              <div key={index} className="col-md-6 colSpace">
                <div className="skills-list">
                  <div className="skill-title border-line-h">
                    <div className="icon">
                      <i className={`fa ${skillSet.icon}`}></i>
                    </div>
                    <div className="name">{skillSet.title}</div>
                  </div>
                  <ul>
                    {skillSet.items.map((skill, skillIndex) => (
                      <li key={skillIndex} className="border-line-h">
                        <div className="name">{skill.name}</div>
                        <div className="progress">
                          <div
                            className="percentage"
                            style={{ width: `${skill.percentage}%` }}
                          ></div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
          <div className="row row-margin border-line-v">
            <div className="col-md-6 colSpace">
              <div className="skills-list circles">
                <div className="skill-title border-line-h">
                  <div className="icon">
                    <i className={`fa ${skills.frontend.icon}`}></i>
                  </div>
                  <div className="name">{skills.frontend.title}</div>
                </div>
                <ul>
                  {skills.frontend.items.map((skill, index) => (
                    <li key={index}>
                      <div className="name">{skill.name}</div>
                      <div className={`progress p${skill.percentage}`}>
                        <span>{skill.percentage}%</span>
                        <div className="slice">
                          <div
                            className="bar"
                            style={{ transform: `rotate(${skill.percentage * 3.6}deg)` }}
                          ></div>
                          <div className="fill"></div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-md-6 colSpace">
              <div className="skills-list list">
                <div className="skill-title border-line-h">
                  <div className="icon">
                    <i className={`fa ${skills.knowledge.icon}`}></i>
                  </div>
                  <div className="name">{skills.knowledge.title}</div>
                </div>
                <ul className="knowladge-list">
                  {skills.knowledge.items.map((item, index) => (
                    <li key={index}>
                      <div className="icon">
                        <i className="fa fa-check" aria-hidden="true"></i>
                      </div>
                      <div className="name">{item}</div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="content testimonials">
        <div className="title">
          <span>{testimonials.title}</span>
        </div>
        <div className="featured-Slider">
          <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-indicators">
              {testimonials.items.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  data-bs-target="#carouselExampleIndicators"
                  data-bs-slide-to={index}
                  className={index === 0 ? 'active' : ''}
                  aria-current={index === 0 ? 'true' : 'false'}
                  aria-label={`Slide ${index + 1}`}
                ></button>
              ))}
            </div>
            <div className="carousel-inner">
              {testimonials.items.map((testimonial, index) => (
                <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                  <div className="revs-item">
                    <div className="text">{testimonial.text}</div>
                    <div className="user">
                      <div className="img">
                        <img src={testimonial.image} alt="" />
                      </div>
                      <div className="info">
                        <div className="name">{testimonial.name}</div>
                        <div className="company">{testimonial.position}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div> */}
    </div>
  </div>
);

export default Resume;
